import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { IndustryMarquee } from "@/components/portfolio/IndustryMarquee";
import { About } from "@/components/portfolio/About";
import { Stats } from "@/components/portfolio/Stats";
import { Capabilities } from "@/components/portfolio/Capabilities";
import { Experience } from "@/components/portfolio/Experience";
import { Ambitions } from "@/components/portfolio/Ambitions";
import { Manifesto } from "@/components/portfolio/Manifesto";
import { Competencies } from "@/components/portfolio/Competencies";
import { Contact } from "@/components/portfolio/Contact";
import { Footer } from "@/components/portfolio/Footer";
import { GalleryPage } from "@/components/portfolio/GalleryPage";

const Home = () => (
  <main>
    <Hero />
    <IndustryMarquee />
    <About />
    <Stats />
    <Capabilities />
    <Experience />
    <Ambitions />
    <Manifesto />
    <Competencies />
    <Contact />
  </main>
);

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <BrowserRouter>
        <ScrollManager />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{ style: { background: "#103a2a", border: "1px solid #1f4534", color: "#fff" } }}
        />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
